import { WritableAtom, atom } from 'jotai';

import { DeliveryMethod } from '../DeliveryMethod';

type DeliveryMethodSettings<T> = Record<DeliveryMethod, T> & {
  rosteredRoomSetting: T;
};

/**
 * This is an atom used to store a launch setting.
 * Since the launch settings have different values when the delivery method changes
 * this takes in a record which configures the different values for each delivery method.
 *
 * Supports both boolean settings (e.g. showFeedback) and numeric settings (e.g. quizTimerSeconds).
 */
export function launchSettingAtom(
  settings: DeliveryMethodSettings<boolean>
): WritableAtom<
  boolean,
  [value: boolean | DeliveryMethod, isRoomRostered?: boolean],
  void
>;

export function launchSettingAtom(
  settings: DeliveryMethodSettings<number>
): WritableAtom<
  number,
  [value: number | DeliveryMethod, isRoomRostered?: boolean],
  void
>;

export function launchSettingAtom(settings: DeliveryMethodSettings<any>) {
  const initialValue = settings[DeliveryMethod.InstantFeedback];
  const internalAtom = atom(initialValue);
  return atom(
    (get) => get(internalAtom),
    (_get: any, set: any, value: any, isRoomRostered = false) => {
      if (typeof value !== 'string') {
        set(internalAtom, value);
      } else {
        const defaultValue = settings[value as DeliveryMethod];
        set(
          internalAtom,
          isRoomRostered ? settings.rosteredRoomSetting : defaultValue
        );
      }
    }
  );
}
